const TIERS: ReadonlyArray<{ upToInclusive?: number; percent: number }> = [
  { upToInclusive: 300, percent: 30 },
  { upToInclusive: 1000, percent: 24 },
  { upToInclusive: 5000, percent: 18 },
  { upToInclusive: 15000, percent: 14 },
  { percent: 11 },
]

export function recuperaCommissionPercent(amount: number): number {
  for (const tier of TIERS) {
    if (tier.upToInclusive === undefined || amount <= tier.upToInclusive) {
      return tier.percent
    }
  }
  return TIERS[TIERS.length - 1]!.percent
}
